import { realEstateFiltersDict, itemByLocales } from '@monoimin/intl';

import {
  BEDROOMS,
  EMPTY_FILTER_ITEMS,
  ESTATE_FILTER_KEYS,
  FILTER_VARIANTS,
  MAX_PRICE,
  MIN_PRICE,
} from '../constants';

import type { FilterConfigs } from '../types';

export const publicFilterConfigs: FilterConfigs = [
  {
    filterKey: ESTATE_FILTER_KEYS.COUNTRY,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'termOptionAll',
    searchPlaceholderDictionaryKey: 'findCountry',
    filterItems: EMPTY_FILTER_ITEMS,
    withSearch: true,
    variant: 'column',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.CITY,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'allCities',
    searchPlaceholderDictionaryKey: 'findCity',
    filterItems: EMPTY_FILTER_ITEMS,
    withSearch: true,
    variant: 'column',
  },
  {
    filterKey: {
      from: ESTATE_FILTER_KEYS.PRICE_FROM,
      to: ESTATE_FILTER_KEYS.PRICE_TO,
    },
    filterVariant: FILTER_VARIANTS.RANGE,
    placeholderDictionaryKey: 'anyPrice',
    fromPlaceholderDictionaryKey: 'priceFrom',
    toPlaceholderDictionaryKey: 'priceTo',
    min: MIN_PRICE,
    max: MAX_PRICE,
    step: 10,
    variant: 'select',
    hideInput: true,
  },
  {
    filterKey: ESTATE_FILTER_KEYS.OBJECT_TYPE,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'propertyType',
    filterItems: realEstateFiltersDict.objectTypes,
    variant: 'column',
  },
  {
    filterKey: ESTATE_FILTER_KEYS.BEDROOMS,
    filterVariant: FILTER_VARIANTS.SELECT,
    placeholderDictionaryKey: 'bedrooms',
    filterItems: itemByLocales(BEDROOMS),
    variant: 'row',
  },
];
